// ──────────────────────────────────────────────────────────────────────────
// Site-wide constants
//
// Edit values here to update them everywhere they appear across the site
// (navbar, footer, hero, about, contact, page copy, etc.).
//
// Anything user-facing that you might want to change later — clinic name,
// email, phone, address, social links, hours — lives here. Components
// import these constants instead of hard-coding the values.
// ──────────────────────────────────────────────────────────────────────────

// ── Brand ──────────────────────────────────────────────────────────────────
export const CLINIC_NAME       = 'Doctors Plaza - Polyclinic';
// CLINIC_SHORT_NAME is used in places where the full name reads awkwardly,
// e.g. "Why Choose <short>" or "Ready to be part of <short>?".
export const CLINIC_SHORT_NAME = 'Doctors Plaza';
export const CLINIC_TAGLINE    = 'Premium Healthcare · Siddipet';
export const CLINIC_LOCATION   = 'Siddipet';
export const CLINIC_STATE      = 'Telangana';
export const LAUNCH_YEAR       = 2026;

// ── Contact ────────────────────────────────────────────────────────────────
export const EMAIL             = 'info@doctorsplazasiddipet.com';

// PHONE is the dial-able number (used in tel: links — keep digits + optional
// country code, no spaces). PHONE_DISPLAY is the human-readable version.
export const PHONE             = '+919398098307';
export const PHONE_DISPLAY     = '+91 93980 98307';

// ── Address ────────────────────────────────────────────────────────────────
// ADDRESS_SHORT is a one-liner used in footers and small cards.
// ADDRESS_LINES is rendered line-by-line (e.g. on the Contact page).
export const ADDRESS_SHORT     = 'Housing Board Colony, Siddipet';
export const ADDRESS_LINES     = [
  '18-18-177/3, Housing Board Colony,',
  'Behind MLA Camp Office, Siddipet,',
  'Telangana',
];
// Optional: a URL that opens the location in Google Maps.
export const MAPS_URL          = 'https://maps.google.com/?q=Doctors+Plaza+Siddipet';

// ── Hours ──────────────────────────────────────────────────────────────────
// Each row is [day-label, time-label]. Order = display order.
export const HOURS = [
  ['Mon – Fri', '9:00 AM – 8:00 PM'],
  ['Saturday',  '9:00 AM – 6:00 PM'],
  ['Sunday',    '10:00 AM – 2:00 PM'],
];
// Compact two-line summary used in the footer.
export const HOURS_SUMMARY = {
  weekday: 'Mon–Sat: 9 AM – 8 PM',
  sunday:  'Sunday: 10 AM – 2 PM',
};

// ── Social ─────────────────────────────────────────────────────────────────
// Handle is the @name shown on screen; URL is what the icon links to.
export const INSTAGRAM_HANDLE  = '@doctorsplazasiddipet';
export const INSTAGRAM_URL     = 'https://instagram.com/doctorsplazasiddipet';
// WhatsApp click-to-chat. Strip the leading "+" from PHONE for wa.me links.
export const WHATSAPP_URL      = `https://wa.me/${PHONE.replace(/^\+/, '')}`;
export const FACEBOOK_URL      = 'https://facebook.com/doctorsplazasiddipet';
